import {baseAxios} from '../helper/axiosHelper';

export const timerecService = {
    insertTimeRec,
    getTimeRecs,
    updateTimeRec,
    deleteTimeRec,
    getTimeModels,
    insertTimeModel,
    updateTimeModel,
    deleteTimeModel,
    insertTimeRecStd,
    getTimeRecsStd,
    updateTimeRecStd,
    deleteTimeRecStd,
    insertTimeRecsFromStd,
    addPause,
    getAllMyHoursByYear
};

function insertTimeRec(data) {

    return baseAxios.post('timerec/timerec',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateTimeRec(data) {

    return baseAxios.put('timerec/timerec',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function addPause(data) {

    return baseAxios.put('timerec/timerec/pause',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteTimeRec(id) {

    return baseAxios.delete('timerec/timerec',{params: {id: id}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getAllMyHoursByYear() {

    return baseAxios.get('timerec/timerec/my/hours')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getTimeRecs(year) {

    return baseAxios.get('timerec/timerec/my',{params: {year: year}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getTimeModels() {

    return baseAxios.get('timerec/timemodels')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function insertTimeModel(data) {

    return baseAxios.post('timerec/timemodel',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateTimeModel(data) {

    return baseAxios.put('timerec/timemodel',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function deleteTimeModel(id) {

    return baseAxios.delete('timerec/timemodel',{params: {id: id}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function insertTimeRecStd(data) {

    return baseAxios.post('timerec/timerecstd',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateTimeRecStd(data) {

    return baseAxios.put('timerec/timerecstd',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function deleteTimeRecStd(id) {

    return baseAxios.delete('timerec/timerecstd',{params: {id: id}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getTimeRecsStd(guid) {

    return baseAxios.get('timerec/timerecstd/my',{params: {userguid: guid}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function insertTimeRecsFromStd(data) {

    return baseAxios.post('timerec/timerec/std',{text:data})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
